// todo: jsdoc this
const tryCall = async call => {
  try {
    const result = await call()
    return {
      success: true,
      data: result,
      error: null,
    }
  } catch (e) {
    return {
      success: false,
      data: null,
      error: e,
    }
  }
}

export default tryCall
